/*
 * Recently Viewed — TRACKER (yazıcı) | eroticshop.com.tr
 * Yalnız PDP'de yüklenir. Display'den bağımsız: şerit o sayfada olmasa da geçmiş yazılır.
 * Veri: window.__eroRV = { id, handle }  →  localStorage['ero_rv'] = [{id,handle}, ...] (en yeni başta)
 */
(function () {
  'use strict';

  var RV_CAP = 15;

  var meta = window.__eroRV;
  if (!meta || !meta.id || !meta.handle) return;
  /* Per-user gizlilik: misafirde geçmiş HİÇ yazılmaz (karar 17 Tem 2026) */
  if (!meta.cid) return;
  var LS_KEY = 'ero_rv__' + meta.cid;

  var id = Number(meta.id);
  if (!id) return;

  var list;
  try {
    list = JSON.parse(localStorage.getItem(LS_KEY)) || [];
    if (!Array.isArray(list)) list = [];
  } catch (e) {
    list = [];
  }

  // Mevcut id'yi çıkar (tekille) → en başa ekle
  list = list.filter(function (item) { return item && Number(item.id) !== id; });
  list.unshift({ id: id, handle: String(meta.handle) });

  if (list.length > RV_CAP) list = list.slice(0, RV_CAP);

  try {
    localStorage.setItem(LS_KEY, JSON.stringify(list));
  } catch (e) { /* quota/private mode: sessizce geç */ }
})();